import React from "react"
import styled from "styled-components"
import media from "styles/media"
import text from "styles/text"
import ContentWidth from "components/ContentWidth"
import MarketoForm from "./MarketoForm"
import useMedia from "utils/useMedia"
import ReactPlayer from "react-player"
import richTextRenderer from "../utils/richTextRenderer"

const ResourceForm = ({ content }) => {
  const videoWidth = useMedia("376px", "26.111vw", "36.719vw", "87.85vw")
  const videoHeight = useMedia("212px", "14.722vw", "20.703vw", "49.533vw")

  return (
    <ContentWidth>
      <Wrapper>
        <ContentContainer>
          {content?.resourceEyebrow && (
            <Eyebrow>{content?.resourceEyebrow}</Eyebrow>
          )}
          {content?.gatedImage?.sourceUrl && (
            <GatedImage
              src={content?.gatedImage?.sourceUrl}
              alt="gated-image"
            />
          )}
          {content?.bodyHeader && (
            <BodyHeader>{content?.bodyHeader}</BodyHeader>
          )}
          {content?.body && <Body>{richTextRenderer(content?.body)}</Body>}
          {content?.gatedVideo && (
            <Video
              url={content?.gatedVideo}
              controls={true}
              light={content?.videoThumbnail?.sourceUrl}
              playing={true}
              volume={1}
              muted={false}
              width={videoWidth}
              height={videoHeight}
            />
          )}
        </ContentContainer>
        <FormContainer>
          <MarketoForm
            id={content.formId}
            ty={content?.thankYouPage}
            mode={content?.formBackground}
          />
        </FormContainer>
      </Wrapper>
    </ContentWidth>
  )
}
export default ResourceForm

const Video = styled(ReactPlayer)`
  .react-player__shadow {
    display: none !important;
  }
`

const FormContainer = styled.div`
  display: flex;
  background-color: ${props => `#${props.Bg}`};
  border-radius: 1.667vw;
  width: auto;

  ${media.fullWidth} {
    border-radius: 24px;
  }
  ${media.tablet} {
    max-width: 42.313vw;
    border-radius: 2.344vw;
  }
  ${media.mobile} {
    border-radius: 5.607vw;
    margin: 0 auto;
  }
`
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  gap: 2.778vw;
  width: 39.028vw;
  max-width: 100%;

  ${media.fullWidth} {
    gap: 40px;
    width: 564px;
  }
  ${media.tablet} {
    gap: 3.906vw;
    width: 44.824vw;
  }
  ${media.mobile} {
    gap: 10.748vw;
    width: 87.85vw;
  }
`
const Eyebrow = styled.p`
  ${text.eyebrow};

  ${media.mobile} {
    ${text.eyebrow};
  }
`
const Header = styled.h2`
  ${text.h2};

  ${media.mobile} {
    ${text.h2};
  }
`
const GatedImage = styled.img`
  width: 26.111vw;
  ${media.fullWidth} {
    width: 376px;
  }

  ${media.tablet} {
    width: 36.719vw;
  }

  ${media.mobile} {
    width: 100%;
  }
`
const BodyHeader = styled.h3`
  ${text.h3}
`
const Body = styled.div`
  position: relative;
  ${text.bodyMd};
  display: flex;
  gap: 1.778vw;
  flex-direction: column;
`
const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 2.778vw;
  width: 100vw;

  ${media.fullWidth} {
    gap: 40px;
    width: 1440px;
  }

  ${media.tablet} {
    width: 100vw;
    gap: 3.906vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 10.667vw;
    width: 88vw;
  }
`
